export default {
  // SET CATEGORIES STORE GENERAL
  /*obtengo todos las categories*/
  SET_TOKEN: function(state, token) {
    state.token = token;
  },

  SET_URSER_GEO: function(state, data) {
    state.userGeo = data;
  },

  SET_LOGGED_STATUS: function(state, data) {
    state.isLoggedIn = data;
  },
};
